/**
 * `GET /api/clients/me/work` — everything the studio has in flight, a page at a time.
 *
 * The one cursor-paged read in the client portal, and the first call site of
 * `useApiPages` outside the studio. The dashboard's "What we are working on" block
 * names five rows and refers here; this is what answers the rest.
 *
 * It pages rather than asking for everything, because one production client already
 * has twenty-four rows and nothing bounds the number a busy month can hold — which is
 * `.docs/24`'s scale rule and the reason the page exists at all.
 *
 * **No `limit`.** The route's own default is what a page is, and sending one would
 * put the page size in two places; the cursor is the only thing that travels.
 */

import { useApiPages } from '../hooks.js'
import { queryKeys } from '../keys.js'

export function useWorkInFlight() {
  return useApiPages({
    key: queryKeys.tasks.work(),
    request: (api, cursor) =>
      api.rest.clients.me.work.$get({ query: cursor === undefined ? {} : { cursor } }),
    nextCursor: (page) => page.next_cursor,
  })
}
